import React, { useState } from "react";
import { Button, ModalProps } from "antd";
import CommonModal from "./CommonModal";
import { useAppDispatch } from "../../utils/hooks/hooks";
import { doLogout, setSessionTimeOut } from "../../store/AuthSlice";
import { useNavigate } from "react-router-dom";

interface LogOutModalProps extends ModalProps {
  close: any;
  open: any;
}

/**
 * Renders a modal component for confirmation of logging out.
 *
 * @param {Object} props - The component props.
 * @param {Function} props.close - The function to close the modal.
 * @param {boolean} props.open - Whether the modal is open or not.
 * @return {JSX.Element} The rendered modal component.
 */
const LogoutModal: React.FC<LogOutModalProps> = ({
  close,
  open,
}) => {
  const dispatch = useAppDispatch();
  const [saving, setSaving] = useState<boolean>(false);
  const navigate = useNavigate();
  
  const onYesClick = () => {
    setSaving(true);
    dispatch(doLogout())
    .then(() => {
          navigate("/login");
          dispatch(setSessionTimeOut(false))
        close();
      })
      .finally(() => setSaving(false));
  };

  return  (
    <CommonModal
      className="deleteModal"
      title={`Log Out?`}
      open={open}
      onCancel={close}
      footer={[
        <Button key="2" htmlType="button" className="cancelBtn" onClick={close}>
          No
        </Button>,
        <Button
          key="1"
          htmlType="button"
          type="primary"
          loading={saving}
          onClick={onYesClick}
        >
          Yes
        </Button>,
      ]}
    >
      <div className="deleteNote">
        Are you sure you want to Log Out?
      </div>
    </CommonModal>
  ) 
};
export default LogoutModal;
